<h1>{{ 'payments.payment-failed' | translate }}</h1>

<p>{{ 'payments.payment-failed-text' | translate }}</p>

<button class="default-btn" [routerLink]="['/']">
    <span>{{ 'general.alerts.ok-btn' | translate }}</span>
</button>
